export const Roles = {
  solutionOwner: "Solution Owner",
  srSolutionOwner: "Senior Solution Owner",
  programSolutionOwner: "Program Solution Owner",
  frontEndEngineer: "Front End Engineer",
  smeArchitect: "SME Architect",
  smeDatabase: "SME Database",
  sme: "SME",
  leadDataArchitect: "Lead Data Architect",
  leadEngineer: "Lead Engineer",
  uxDesigner: "UX Designer",
  xd: "Experience Design",
  lvd: "Lead Visual Designer",
  fullStackEngineer: "Full Stack Engineer",
  softwareEngineer: "Software Engineer",
  qualityLead: "Lead Quality Engineer",
  qualityEngineer: "Quality Engineer",
  architect: "Architect",
  dataAnalytics: "Data & Analytics",
  devOps: "DevOps",
  producer: "Producer",
  leadership: {
    projectLead: "Project Lead",
    projectSupport: "Project Support",
    festivalCreator: "Festival Creator",
    projectAdvisor: "Project Advisor",
    marketingLead: "Marketing Lead",
    eventsPlatformLead: "Events Platform Lead",
    founder: "Founder",
    isg: "Information Security & Governance",
    programDirector: "Program Director",
    programManager: "Program Manager",
    corporateCounsel: "Corporate Councel",
    vp: "VP",
    dataPrivacy: "Data Privacy",
    analyst: "Analyst",
    legal: "Legal",
    operations: "Operations",
    solutionArchitect: "Lead Solution Architect"
  }
};
